//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var RecentClientSearchGetMapper = function (response) {
    return response;
};
export var RecentClientSearchSaveMapper = function (response) {
    return response;
};
export var TrxTypeListMapper = function (response) {
    return response;
};
export var UserPopupStatusMapper = function (response) {
    return response;
};
export var UserPopupStatusSaveMapper = function (response) {
    return response;
};
export var ValidateClientMapper = function (response) {
    return response;
};
export var HoldingSummaryMapper = function (response) {
    return response;
};
export var FolioDetailsMapper = function (response) {
    var res = response.data.map(function (item) {
        if (item === null || item === void 0 ? void 0 : item.totalqty) {
            item.totalqty = parseFloat(item.totalqty.toFixed(2));
        }
        return item;
    });
    return __assign(__assign({}, response), { data: res });
};
export var HoldingQtyDetailsMapper = function (response) {
    return response;
};
export var AggregatedHoldingMapper = function (response) {
    return response;
};
export var UccClientSearchMapper = function (response) {
    return response;
};
